export default __webpack_public_path__ + "static/media/project_visual_14.3bbbd7b8.jpg";